import { AppService } from 'src/app/Services/application/app.service';
import { UserappinstanceService } from 'src/app/Services/userappinstnce/userappinstance.service';
import { Router } from '@angular/router';
import { Component, OnInit, Injector } from '@angular/core';
import { UserAppInstance } from 'src/app/Models/UserAppInstance';
import { TranslateService } from '@ngx-translate/core';
import { KeycloakService } from 'keycloak-angular';
import { PortalInfoService } from 'src/app/Services/portal-info/portal-info.service';
import { Title } from '@angular/platform-browser';
import { Home1Component } from '../home1/home1.component';
import { KeycloakProfile } from 'keycloak-js';
import { Urls } from 'src/app/Models/Urls';
import { CookieService } from 'ngx-cookie-service';
import { NotificationService } from 'src/app/Services/notification/notification.service';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/Services/auth/auth.service';
import { Variables } from 'src/app/Models/variables';
import * as CryptoJS from 'crypto-js';
import { AppComponent } from 'src/app/app.component';

@Component({
  selector: 'app-manage-instances',
  templateUrl: './manage-instances.component.html',
  styleUrls: ['./manage-instances.component.css']
})
export class ManageInstancesComponent implements OnInit {

  instances = [];

  isLoadMore = true;
  page = 1;
  size = 100;

  title: string;
  fullName: string;

  userDetails: KeycloakProfile;
  isManage: boolean;
  http: any;

  urls = new Urls();
  organisation: any;

  items: MenuItem[];
  options = [];
  isAccount = false;
  isLanguage: boolean;
  load = false;

  isperm = false;

  portalHeaderColor = 'transparent';

  icon: any;

  constructor(
    private router: Router,
    private userInstanceService: UserappinstanceService,
    private translate: TranslateService,
    // private keycloakService: KeycloakService,
    private portalinfo: PortalInfoService,
    private titleService: Title,
    private home: Home1Component,
    private cookieService: CookieService,
    private confirmationService: ConfirmationService,
    private notificationSvc: NotificationService,
    private appservice: AppService,
    private injector: Injector,
    private auth: AuthService,
    private app: AppComponent
  ) {
    if (localStorage.getItem('portal-title') === null) {
      // tslint:disable-next-line: deprecation
      portalinfo.getPortalInfo().subscribe((res) => {
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < res.length; i++) {
          this.title = res[i].portalTitle;
          localStorage.setItem('portal-title', res[i].portalTitle);
          localStorage.setItem('portal-id', JSON.stringify(res[i].portalId));
          this.portalHeaderColor = res[i].portalHeaderColor;
          localStorage.setItem('headercolor', res[i].portalHeaderColor);

          this.titleService.setTitle(res[i].portalTitle);
        }
      });
    } else {
      this.title = localStorage.getItem('portal-title');
      this.titleService.setTitle(this.title);

      this.portalHeaderColor = localStorage.getItem('headercolor');
    }

    this.icon = app.icon;

    // translate.addLangs(['English', 'French']);
    // translate.setDefaultLang('English');

    // let browserLang = translate.getBrowserLang();
    // if (localStorage.getItem('language') !== null) {
    //   browserLang = localStorage.getItem('language');
    // }
    // translate.use(browserLang.match(/English|French/) ? browserLang : 'English');

    translate.use('English');

    // tslint:disable-next-line: deprecation
    this.translate.get('MANAGE.APPS').subscribe((resp1: string) => {
      // tslint:disable-next-line: deprecation
      this.translate.get('MANAGE.INSTANCES').subscribe((resp2: string) => {
        // tslint:disable-next-line: deprecation
        this.translate.get('GENERAL.MANAGEPORTALINFO').subscribe((resp3: string) => {
          // tslint:disable-next-line: deprecation
          this.translate.get('GENERAL.ICONS').subscribe((resp4: string) => {
            this.items = [];
            this.items.push({ label: resp1, routerLink: ['/manageapps'] });
            this.items.push({ label: resp2, routerLink: ['/manageinstances'] });

            const v = new Variables();
            const va = localStorage.getItem('eu');
            const eu = CryptoJS.AES.decrypt(va, v.pass).toString(CryptoJS.enc.Utf8);
            const usr = JSON.parse(eu);

            const og = usr.organisationName;
            if (og === 'ORG_SUPER_ADMIN') {
              this.isLanguage = true;
              this.isManage = true;
              this.items.push({ label: resp3, routerLink: ['/portalinfo'] });
            }
            this.items.push({ label: resp4, routerLink: ['/icons'] });
          });
        });
      });
    });

    // tslint:disable-next-line: deprecation
    this.translate.get('GENERAL.EDIT').subscribe((resp1: string) => {
      // tslint:disable-next-line: deprecation
      this.translate.get('GENERAL.DELETE').subscribe((resp2: string) => {
        this.options = [
          { label: resp1, value: 'Edit' },
          { label: resp2, value: 'Delete' }
        ];
      });
    });

    this.loadUserProfile();
   }

  ngOnInit() {
    localStorage.removeItem('inst_detail');
    this.getInstances();
  }

  createAppInstance() {
    this.router.navigateByUrl('/createinstance');
  }

  getInstances() {
    this.load = true;
    // tslint:disable-next-line: deprecation
    this.userInstanceService.getUserAppInstancesPageSize(this.page, this.size).subscribe((instances) => {
      const insts = [];
      // tslint:disable-next-line: prefer-for-of
      for (let j = 0; j < instances.length; j++) {
        instances[j].options = this.options;
        instances[j].params = instances[j].instanceParameters;
        if (instances[j].instanceParameters.trim() === '') {
          // tslint:disable-next-line: deprecation
          this.translate.get('GENERAL.NOPARAMETERS').subscribe((res) => {
            instances[j].params = res;
          });
        }
        if (instances[j].instanceTarget === 'content') {
          // tslint:disable-next-line: deprecation
          this.translate.get('GENERAL.CONTENTOPTION').subscribe((res) => {
            instances[j].targ = res;
          });
        } else if (instances[j].instanceTarget === 'new_tab') {
          // tslint:disable-next-line: deprecation
          this.translate.get('GENERAL.NEWTABOPTION').subscribe((res) => {
            instances[j].targ = res;
          });
        }
        this.instances.push(instances[j]);
      }
      if (instances.length < this.size) {
        this.isLoadMore = true;
      } else {
        this.isLoadMore = false;
      }
      this.load = false;
      /*this.instances.sort((a, b) => {
        if (a.instanceName < b.instanceName) { return -1; }
        if (a.instanceName > b.instanceName) { return 1; }
        return 0;
      });*/
    }, err => this.handleError(err));
  }

  saveInstance(event, instance) {
    if (event.value === 'Edit') {
      localStorage.setItem('inst_detail', JSON.stringify(instance));
      this.router.navigateByUrl('/instancedetail');
    } else if (event.value === 'Delete') {
      this.deleteInstance(instance);
    }
  }

  deleteInstance(instance) {
    this.load = true;
    // tslint:disable-next-line: deprecation
    this.userInstanceService.deleteAppInstance(instance.instanceId).subscribe((resp) => {
      if (resp === true) {
        let alrt: string;
        // tslint:disable-next-line: deprecation
        this.translate.get('ALERT.DELETED').subscribe((res: string) => {
          alrt = res;
          this.notificationSvc.info('', alrt, 2000);
        });
        this.instances = [];
        this.getInstances();
      } else {
        this.load = false;
        let alrt: string;
        // tslint:disable-next-line: deprecation
        this.translate.get('ALERT.COULDNOTDELETEINSTANCE').subscribe((res: string) => {
          alrt = res;
          this.confirm(alrt);
        });
      }
    }, err => this.handleError(err));
  }

  changePass() {
    this.router.navigateByUrl('/change-password');
  }

  changePin() {
    this.router.navigateByUrl('/change-pin');
  }

  loadMore() {
    this.page += 1;
    this.getInstances();
  }

  confirm(msg) {
    this.confirmationService.confirm({
        message: msg,
        accept: () => {
            // Actual logic to perform a confirmation
        }
    });
  }

  handleError(err) {
    this.load = false;
    console.log(err);
  }







  gotoAccount() {
    const variables = new Variables();
    window.open(this.urls.keycloakUrl + '/auth/realms/' + variables.realm + '/account');
  }

  gotoLanguage() {
    this.router.navigateByUrl('/language');
  }

  logout() {
    localStorage.clear();

    this.cookieService.delete('goepla-portal-organisation-id');
    this.cookieService.delete('goepla-portal-user-id');
    this.cookieService.delete('goepla-portal-language');

    if (environment.useKeycloak === 'true') {
      const keycloakService = this.injector.get(KeycloakService);
      keycloakService.logout(this.urls.appUrl + '/');
    } else {
      this.auth.logout();
      // window.location.reload();
    }
  }

  async loadUserProfile() {
    if (environment.useKeycloak === 'true') {
      const keycloakService = this.injector.get(KeycloakService);
      keycloakService.loadUserProfile().then((user) => {
        this.fullName = user.firstName + ' ' + user.lastName;
        if (localStorage.getItem('fullname') != null) {
          this.fullName = localStorage.getItem('fullname');
        }

        const v = new Variables();
        const va = localStorage.getItem('eu');
        const eu = CryptoJS.AES.decrypt(va, v.pass).toString(CryptoJS.enc.Utf8);
        const usr = JSON.parse(eu);

        if (va !== null) {
          const extUser = usr;
          this.organisation = extUser.organisationName;
        }
      });
    } else {
      const v = new Variables();
      const va = localStorage.getItem('eu');
      const eu = CryptoJS.AES.decrypt(va, v.pass).toString(CryptoJS.enc.Utf8);
      const user = JSON.parse(eu);

      this.organisation = user.organisationName;
      this.fullName = user.firstName + ' ' + user.lastName;
    }
  }

  gotoManage() {
    this.router.navigateByUrl('/manage');
  }
}
